module.exports = __webpack_public_path__ + "static/img/new_logo_9.dc26370d.png";